import mutations from '@fps/vue-toolkit/dist/store/mutationlist';

export default Object.assign({}, mutations, {
  SET_ASSIGN: 'SET_ASSIGN',
  SET_DEEP: 'SET_DEEP',
  MENU_LEFT: 'MENU_LEFT',
});



// WEBPACK FOOTER //
// ./src/store/mutationlist.js